/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Brand-summary': {
    width: 26,
    height: 26,
    viewBox: '0 0 26 26',
    data: '<path pid="0" d="M7.583 20.584h10.834V4.334H7.583v16.25zm-5.416-2.167H6.5V6.5H2.167v11.917zM19.5 6.5v11.917h4.333V6.5H19.5z" _fill="#9BC225" opacity=".7"/>'
  }
})
